import { LoginForm } from '@/components/login-form';
import { useAuthStore } from '@/stores/auth-store';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { QrCode } from 'lucide-react';

export const Route = createFileRoute('/login')({
  beforeLoad: () => {
    const { token, user } = useAuthStore.getState();
    if (token && user) {
      throw redirect({ to: '/' });
    }
  },
  component: LoginPage,
});

function LoginPage() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-6 bg-background p-4">
      <div className="flex items-center gap-2">
        <QrCode className="h-8 w-8 text-primary" />
        <h1 className="text-2xl font-bold tracking-tight">Ticketing</h1>
      </div>
      <LoginForm />
    </main>
  );
}
